import React, { useEffect, useState } from "react";
import "./signupproject.scss";
import { Modal } from "react-bootstrap";
import { Api_Url } from "../../utils/ApiUrl";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import BannerApply from "./BannerApply";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const Signupproject = () => {
  const { t } = useTranslation();

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [loader, setLoader] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [selectedCompanySize, setSelectedCompanySize] = useState(
    t("Signupforproject-t4")
  );
  const [companyError, setCompanyError] = useState("");
  const [nameError, setNameError] = useState("");
  const [twitter, setTwitter] = useState("");
  const [twitterError, setTwitterError] = useState("");
  const [telegram, setTelegram] = useState("");
  const [telegramError, setTelegramError] = useState("");
  const [email, setEmail] = useState("");
  const [emailerrorregister, setEmailErrorRegister] = useState("");
  const [projectIndustry, setProjectIndustry] = useState("");
  const [projectIndustryError, setProjectIndustryError] = useState("");
  const [website, setWebsite] = useState("");
  const [websiteError, setWebsiteError] = useState("");
  const [name, setname] = useState("");
  const [numberError, setNumberError] = useState("");
  const [position, setPosition] = useState("");
  const [positionError, setPositionError] = useState("");

  const handleItemClick = (size) => {
    setSelectedCompanySize(size);
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  // Function to validate social media links
  const isValidSocialLink = (link, type) => {
    let regex;
    if (type === "twitter") {
      regex =
        /^(?:https?:\/\/)?(?:www\.)?(twitter\.com|x\.com)\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-]*)/i;
    } else if (type === "telegram") {
      regex = /^(?:https?:\/\/)?t\.me\/\+?[a-zA-Z0-9\-_]+$/;
    } else if (type === "website") {
      regex =
        /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+)\.([a-zA-Z]{2,})(?:\/\S*)?$/i;
    }
    return regex.test(link);
  };

  const submit = (e) => {
    e.preventDefault();
    if (email.length === 0) {
      setEmailErrorRegister(t("Signupforproject-e1"));
    } else if (!isValidEmail(email)) {
      setEmailErrorRegister(t("Signupforproject-e2"));
    }
    if (projectName.length === 0) {
      setNameError(t("Signupforproject-e3"));
    }
    if (website.length === 0) {
      setWebsiteError(t("Signupforproject-e4"));
    }
    //  else if (!isValidSocialLink(website, "website")) {
    //   setWebsiteError(t("Signupforproject-e5"));
    // }
    if (name.length === 0) {
      setNumberError(t("Signupforproject-e6"));
    }
    if (selectedCompanySize === "Company Size") {
      setCompanyError(t("Signupforproject-e7"));
    }
    if (position.length === 0) {
      setPositionError(t("Signupforproject-e8"));
    }
    if (projectIndustry.length === 0) {
      setProjectIndustryError(t("Signupforproject-e9"));
    }
    if (twitter.length === 0) {
      setTwitterError(t("Signupforproject-e10"));
    }
    // else if (!isValidSocialLink(twitter, "twitter")) {
    //   setTwitterError(t("Signupforproject-e11"));
    // }
    if (telegram.length === 0) {
      setTelegramError(t("Signupforproject-e12"));
    }
    // else if (!isValidSocialLink(telegram, "telegram")) {
    //   setTelegramError(t("Signupforproject-e13"));
    // }
    else {
      var data = JSON.stringify({
        projectName: projectName,
        twitterLink: twitter,
        telegramLink: telegram,
        companySize: selectedCompanySize,
        projectIndustry: projectIndustry,
        website: website,
        telegramHandle: position,
        projectCreatorName: name,
        email: email,
      });
      setLoader(true);

      var config = {
        method: "post",
        url: `${Api_Url}/temp/creator-signup`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          handleShow1();
          setLoader(false);
        })
        .catch(function (error) {
          toast.error(error?.response?.data?.message);
          setLoader(false);
        });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="wrapper-apply">
        <BannerApply />
        <section className="apply-section sectionforsignupproject">
          <div className="custom-container">
            <div className="parent">
              <div className="left-side" style={{ borderRight: "none" }}>
                <div className="main-content">
                  <h4>
                    {/* {t('Unlockwallet')} */}
                    {t("Signupproject1")} <br />{" "}
                    {/* <span>{t("Signupproject2")}</span> */}
                  </h4>
                  <p className="para">{t("UNclockpara")} </p>
                  <div className="inner-twice">
                    <div className="twice-data">
                     <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M20 26.25V23.75C20 22.4239 19.4732 21.1521 18.5355 20.2145C17.5979 19.2768 16.3261 18.75 15 18.75H7.5C6.17392 18.75 4.90215 19.2768 3.96447 20.2145C3.02678 21.1521 2.5 22.4239 2.5 23.75V26.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M20 3.90991C21.0722 4.18787 22.0217 4.81399 22.6996 5.68999C23.3775 6.56599 23.7452 7.64227 23.7452 8.74991C23.7452 9.85755 23.3775 10.9338 22.6996 11.8098C22.0217 12.6858 21.0722 13.3119 20 13.5899" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M27.5 26.25V23.75C27.4992 22.6421 27.1304 21.5659 26.4517 20.6904C25.773 19.8148 24.8227 19.1894 23.75 18.9125" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.25 13.75C14.0114 13.75 16.25 11.5114 16.25 8.75C16.25 5.98858 14.0114 3.75 11.25 3.75C8.48858 3.75 6.25 5.98858 6.25 8.75C6.25 11.5114 8.48858 13.75 11.25 13.75Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      <div className="text">
                        <h5>{t("COmmunitydriven")}</h5>
                        <p>{t("Leveragepara")}</p>
                      </div>
                    </div>
                    <div className="twice-data">
                     <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M18.0879 6.86877L12.4783 6.86877L12.4783 4.11689L18.0879 4.11689L18.0879 6.86877Z" fill="white"/>
  <path d="M18.0879 25.8145L12.4783 25.8145L12.4783 23.0626L18.0879 23.0626L18.0879 25.8145Z" fill="white"/>
  <path d="M23.3799 17.6646L23.3799 12.0549L26.1318 12.0549L26.1318 17.6646L23.3799 17.6646Z" fill="white"/>
  <path d="M4.43457 17.6646L4.43457 12.0549L7.18646 12.0549L7.18646 17.6646L4.43457 17.6646Z" fill="white"/>
  <path d="M22.9922 11.2235L19.0256 7.25692L20.9715 5.31104L24.9381 9.27763L22.9922 11.2235Z" fill="white"/>
  <path d="M9.59473 24.6201L5.62813 20.6535L7.57401 18.7076L11.5406 22.6742L9.59473 24.6201Z" fill="white"/>
  <path d="M19.0996 22.5995L23.0662 18.6329L25.0121 20.5788L21.0455 24.5454L19.0996 22.5995Z" fill="white"/>
  <path d="M5.70312 9.20288L9.66972 5.23629L11.6156 7.18216L7.649 11.1488L5.70312 9.20288Z" fill="white"/>
  <rect x="12.4785" y="12.0549" width="5.60962" height="5.60961" fill="white"/>
</svg>
                      <div className="text">
                        <h5>{t("Easysetup")}</h5>
                        <p>{t("Effortpara")}</p>
                      </div>
                    </div>
                    <div className="twice-data">
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M20 8.75H27.5V16.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M27.5 8.75L16.875 19.375L10.625 13.125L2.5 21.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      <div className="text">
                        <h5>{t("Proven")}</h5>
                        <p>{t("Ensurepara")}</p>
                      </div>
                    </div>
                    <div className="twice-data">
                     <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M14.888 24.149C11.1716 26.2946 6.41943 25.0213 4.27375 21.3049C2.12807 17.5885 3.40141 12.8363 7.11783 10.6906C10.8343 8.54494 15.5864 9.81828 17.7321 13.5347C19.8778 17.2511 18.6044 22.0033 14.888 24.149Z" stroke="white" stroke-width="2.07574"/>
  <path d="M11.2852 6.77617C14.5957 4.04557 19.493 4.51569 22.2236 7.82621C24.9542 11.1367 24.4841 16.034 21.1735 18.7646" stroke="white" stroke-width="2.07574"/>
  <rect x="10.9561" y="14.0619" width="4.87361" height="4.87361" transform="rotate(45 10.9561 14.0619)" fill="white"/>
</svg>
                      <div className="text">
                        <h5>{t("Customizable")}</h5>
                        <p>{t("Rewardpara")}</p>
                      </div>
                    </div>
                    <div className="twice-data">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
  <path d="M14.888 24.149C11.1716 26.2946 6.41943 25.0213 4.27375 21.3049C2.12807 17.5885 3.40141 12.8363 7.11783 10.6906C10.8343 8.54494 15.5864 9.81828 17.7321 13.5347C19.8778 17.2511 18.6044 22.0033 14.888 24.149Z" stroke="white" stroke-width="2.07574"/>
  <path d="M11.2852 6.77617C14.5957 4.04557 19.493 4.51569 22.2236 7.82621C24.9542 11.1367 24.4841 16.034 21.1735 18.7646" stroke="white" stroke-width="2.07574"/>
  <rect x="10.9561" y="14.0619" width="4.87361" height="4.87361" transform="rotate(45 10.9561 14.0619)" fill="white"/>
</svg>
                      <div className="text">
                        <h5>{t("Signupproject3")}</h5>
                        <ul>
                          <li>{t("Signupproject4")}</li>
                          <li>{t("Signupproject5")}</li>
                          <li>{t("Signupproject6")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right-side">
                <Tabs
                  defaultActiveKey="premium"
                  id="uncontrolled-tab-example"
                  className="signup-nav"
                >
                  <Tab eventKey="premium" title={t("Signupproject13")}>
                    <div className="apply-box">
                      <h6 className="main-head">
                        {/* {t('Fillinthe')} */}
                        {t("Signupproject7")}{" "}
                     
                      </h6>
                      <p className="para">{t("PleasefillPara")}</p>
                      <div className="bottom-content">
                        <div className="option-field">
                          <input
                            value={projectName}
                            onChange={(e) => (
                              setProjectName(e.target.value), setNameError("")
                            )}
                            type="text"
                            placeholder={t("Signupforproject-t3")}
                          />
                          {nameError ? (
                            <p className="error-message">{nameError}</p>
                          ) : null}
                        </div>
                        <div className="option-field">
                          <div className="dropdown">
                            <button
                              className="dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {selectedCompanySize === "Company Size" ? (
                                <>{selectedCompanySize}</>
                              ) : (
                                <h6 style={{ color: "#FFF" }}>
                                  {selectedCompanySize}
                                </h6>
                              )}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="8"
                                viewBox="0 0 15 8"
                                fill="none"
                              >
                                <path
                                  d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                                  fill="#D1DADD"
                                />
                                <path
                                  d="M15 0.500244L15 3.47081L7.76667 7.50024L7.76667 4.52968L15 0.500244Z"
                                  fill="#D1DADD"
                                />
                              </svg>
                            </button>
                            {companyError ? (
                              <p className="error-message">{companyError}</p>
                            ) : null}
                            <ul className="dropdown-menu">
                              <li>
                                <a
                                  className="dropdown-item"
                                  // href="#"
                                  onClick={() => (
                                    handleItemClick("1-10"), setCompanyError("")
                                  )}
                                >
                                  1-10
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item"
                                  // href="#"
                                  onClick={() => (
                                    handleItemClick("10-50"),
                                    setCompanyError("")
                                  )}
                                >
                                  10-50
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item"
                                  // href="#"
                                  onClick={() => (
                                    handleItemClick("50-100"),
                                    setCompanyError("")
                                  )}
                                >
                                  50-100
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item"
                                  // href="#"
                                  onClick={() => (
                                    handleItemClick("100+"), setCompanyError("")
                                  )}
                                >
                                  above 100
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="option-field">
                          <input
                            value={projectIndustry}
                            onChange={(e) => (
                              setProjectIndustry(e.target.value),
                              setProjectIndustryError("")
                            )}
                            type="text"
                            placeholder={t("Signupforproject-t5")}
                          />
                          {projectIndustryError ? (
                            <p className="error-message">
                              {projectIndustryError}
                            </p>
                          ) : null}
                        </div>
                        <div className="option-field">
                          <input
                            value={website}
                            onChange={(e) => (
                              setWebsite(e.target.value), setWebsiteError("")
                            )}
                            type="text"
                            placeholder={t("Signupforproject-t6")}
                          />
                          {websiteError ? (
                            <p className="error-message">{websiteError}</p>
                          ) : null}
                        </div>
                        <div className="option-field">
                          <input
                            value={twitter}
                            onChange={(e) => (
                              setTwitter(e.target.value), setTwitterError("")
                            )}
                            type="text"
                            placeholder={t("Signupforproject-t7")}
                          />
                          {twitterError ? (
                            <p className="error-message">{twitterError}</p>
                          ) : null}
                        </div>
                        <div className="option-field">
                          <input
                            value={telegram}
                            onChange={(e) => (
                              setTelegram(e.target.value), setTelegramError("")
                            )}
                            type="text"
                            placeholder={t("Signupforproject-t8")}
                          />
                          {telegramError ? (
                            <p className="error-message">{telegramError}</p>
                          ) : null}
                        </div>
                        <div className="twice-fields">
                          <div className="option-field">
                            <input
                              value={name}
                              onChange={(e) => (
                                setname(e.target.value), setNumberError("")
                              )}
                              type="text"
                              placeholder={t("Signupforproject-t9")}
                            />
                            {numberError ? (
                              <p className="error-message">{numberError}</p>
                            ) : null}
                          </div>
                          <div className="option-field">
                            <input
                              value={position}
                              onChange={(e) => (
                                setPosition(e.target.value),
                                setPositionError("")
                              )}
                              type="text"
                              placeholder={t("Signupforproject-t10")}
                            />
                            {positionError ? (
                              <p className="error-message">{positionError}</p>
                            ) : null}
                          </div>
                        </div>
                        <div className="option-field">
                          <input
                            value={email}
                            onChange={(e) => (
                              setEmail(e.target.value),
                              setEmailErrorRegister("")
                            )}
                            type="text"
                            placeholder={t("Signupforproject-t11")}
                          />
                          {emailerrorregister ? (
                            <p className="error-message">
                              {emailerrorregister}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div onClick={submit} className="btn-sign">
                        {loader ? (
                          <a href="#" className="btn-continue">
                            <img
                              src="\assets\loadingp.png"
                              alt="img"
                              className="img-fluid loading"
                            />
                            {t("Signupforproject-t13")}
                          </a>
                        ) : (
                          <a className="btn-continue">
                            {t("Signupforproject-t12")}
                          </a>
                        )}
                      </div>
                    </div>
                  </Tab>
                  {/* <Tab eventKey="self" title={t("Signupproject9")}>
                    <div className="apply-box">
                      <div className="self-serve">
                        <h5>{t("Signupproject9")}</h5>
                        <p>{t("Signupproject10")}</p>
                        <p>{t("Signupproject11")}</p>
                        <a
                          href="https://creators.gems.vip/signup"
                          target="_blank"
                          className="btn-green"
                        >
                          {t("Signupproject12")}
                        </a>
                      </div>
                    </div>
                  </Tab> */}
                </Tabs>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal
        className="common-modal-style addteammembermodal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Signupforproject-t14")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addedmodal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="89"
              height="88"
              viewBox="0 0 89 88"
              fill="none"
            >
              <path
                d="M77.084 37.9845L77.084 11.417L35.6306 51.7939L10.918 34.7697L10.918 59.3998L35.6306 77.583L77.084 37.9845Z"
                fill="#D1DADD"
              />
            </svg>
            <h6 className="addedhead">{t("Signupforproject-t15")}</h6>
            <button className="btn-green w-100" onClick={() => handleClose1()}>
              {t("Signupforproject-t16")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Signupproject;
